define('formkit/view/form.object/form.object.collection.view',['require','exports','module','underscore','marionette','uikit/uikit','./base.form.object.view','../../templates','../../behavior/bind.option.to.active.section.change.behavior'],function(require, exports, module) {
  //prettier-ignore
  var _                  = require('underscore'),
      Mn                 = require('marionette'),
      UIKit              = require('uikit/uikit'),
      BaseFormObjectView = require('./base.form.object.view'),
      Templates          = require('../../templates'),

  //Behaviors
      BindOptionToActiveSectionChangeBehavior = require('../../behavior/bind.option.to.active.section.change.behavior');

  var DEFAULT_MODEL_ATTRIBUTE_MAP = {
    label: 'label',
    title: 'text',
    description: 'description',
    type: 'type',
  };

  var DEFAULT_TYPE_ATTRIBUTE_MAP = {
    description: 'description',
  };

  var EmptyView = Mn.ItemView.extend({
    template: Templates.App['form.object.collection.empty'],
    className: 'empty-view',
  });

  var FormObjectCollectionView = UIKit.CollectionView.extend({
    className: 'ui formObjects',

    childView: BaseFormObjectView,

    childViewEventPrefix: 'childViewFormObjectView',

    options: {
      designable: false,
      readonly: false,
      empty: true,
    },

    emptyView: EmptyView,

    behaviors: {
      BindOptionToActiveSectionChangeBehavior: {
        behaviorClass: BindOptionToActiveSectionChangeBehavior,
        optionName: 'visible',
        initialValue: false,
        valueWhenActive: true,
        valueWhenInactive: false,
      },
    },

    onFirstRender: function() {
      this.updateCollection();
      this.on('change:visible', function() {
        var self = this;

        // We are wrapping any invocation of updateCollection() after page load in a setTimeout that waits zero seconds
        // We do this to force the evaluation of updateCollection() on the next run loop, thus allowing a section's emptyView
        // to be rendered visibly while its childViews are being compiled and rendered.  We have a "loading" icon that
        // appears in the emptyView that provides a visual cue to the user that the page is indeed being assembled (see
        // PLAT-1511 for details)
        window.setTimeout(function() {
          return self.updateCollection();
        }, 0);
      });
    },

    updateCollection: function() {
      if (this.getOption('visible') && !this.collection) {
        this.collection = this.model.get('children');
      }
    },

    buildChildView: function(child, ChildViewClass, childViewOptions) {
      childViewOptions = _.extend(
        {
          designable: this.getOption('designable'),
          readonly: this.getOption('readonly'),
          form: this.form,
        },
        childViewOptions
      );

      return UIKit.CollectionView.prototype.buildChildView.call(this, child, ChildViewClass, childViewOptions);
    },

    onChangeReadonly: function() {
      this.children.each(function(childView) {
        childView.readonly = this.readonly;
      }, this);
    },

    updateAttributes: function() {
      this.addClass('empty', this.empty);
    },

    onAddChild: function() {
      this.empty = this.isEmpty();
    },

    onRemoveChild: function() {
      this.empty = this.isEmpty();
    },
  });

  module.exports = FormObjectCollectionView;
});

